import { Field } from 'formik';
import React, { useState } from 'react';

interface IProps {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  label?: string;
  name?: string;
  selectedValue?: boolean;
  value?: string;
}

const Toggle: React.FC<IProps> = ({
  checked,
  setChecked,
  label,
  value,
  selectedValue,
  name,
}) => {
  const [selectedOption, setSelectedOption] = useState(selectedValue);
  const handleOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(!selectedOption);
  };

  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <Field
        name={name}
        type="checkbox"
        value={value}
        checked={selectedOption}
        className="mr-3"
        onChange={handleOptionChange}
      />
      <div className="w-14 h-7 bg-border-color peer-focus:outline-none peer-focus:ring-0 rounded-full peer dark:bg-border-color peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-none after:bg-light-grey after:border after:rounded-full after:h-6 after:w-[26px] after:transition-all peer-checked:bg-primary" />
      <span className="ml-3 text-sm font-medium ">{label}</span>
    </label>
  );
};

export default React.memo(Toggle);

// import { Field } from 'formik';
// import React from 'react';

// interface IProps {
//   type?: string;
//   name?: string;
// }

// const Toggle: React.FC<IProps> = ({ type,name}) => {
//   return (
//     <label className="relative inline-flex items-center cursor-pointer">
//       <input
//         type={type}
//         name={name}
//         className={"invisible sr-only peer invisible"}
//       />
//       <div className="w-14 h-7 bg-border-color peer-focus:outline-none peer-focus:ring-0 rounded-full peer dark:bg-border-color peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-none after:bg-light-grey after:border after:rounded-full after:h-6 after:w-[26px] after:transition-all peer-checked:bg-primary" />
//       {/* <span className="ml-3 text-sm font-medium ">{label}</span> */}
//     </label>
//   );
// };

// export default React.memo(Toggle);
